import { render, staticRenderFns } from "./energyRanking.vue?vue&type=template&id=1937b371&scoped=true&"
import script from "./energyRanking.vue?vue&type=script&lang=js&"
export * from "./energyRanking.vue?vue&type=script&lang=js&"
import style0 from "./energyRanking.vue?vue&type=style&index=0&id=1937b371&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937b371",
  null
  
)

export default component.exports